module.exports = __webpack_public_path__ + "img/45.952d0bc7.jpg";